import { render, staticRenderFns } from "./AddFamilyDetails.vue?vue&type=template&id=25a507ca"
import script from "./AddFamilyDetails.vue?vue&type=script&lang=js"
export * from "./AddFamilyDetails.vue?vue&type=script&lang=js"
import style0 from "./AddFamilyDetails.vue?vue&type=style&index=0&id=25a507ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports